import { render } from "./main-layout.vue?vue&type=template&id=033ccd89"
import script from "./main-layout.vue?vue&type=script&lang=js"
export * from "./main-layout.vue?vue&type=script&lang=js"

import "./main-layout.vue?vue&type=style&index=0&id=033ccd89&lang=scss"
script.render = render

export default script